import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ConnUrls from "../../Connections/ConnectURL";
import { MasterContext, MobiOrNotContext } from "../../ContextApi/context";

import utilsCategurys from "../../_Utils/utilsCategurys";
import MyFunctions from "../../myFunctions";
import myFunctions from "../../myFunctions";
import RestSmallBlock from "../../DTechComp/RestSmallBlock";
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';
import { byPlaceRank } from '../../DTechComp/placeRelevance';
import { CityContext } from '../../ContextApi/cityContext';


const CategurysList = (props) => {
    const [master] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [shufMe, setShufMe] = useState();
    const [loading, setLoading] = useState(true);
    // המקום והעיר של הלקוח - השרת מסנן את הרשימה לפיהם; בהחלפה - טעינה מחדש
    const { cityId, myCity } = useContext(CityContext);
    const placeKey = (cityId || "") + "_" + (myCity ? myCity._id : "");
    const params = useParams();
    const [bgImgPos, setBgImgPos] = useState("");
    const [waitImgItm, setWaitImgItm] = useState({});



    useEffect(() => {
        setAll();
        //תמונת ההמתנה של הקטגוריה (נטענת ב-CateguryPage לפני שהרשימה עולה), ואם אין - של המאסטר
        setWaitImgItm(MyFunctions.setTheImgWait(props.catPage || {}, master, mobiOrNot));

    }, [placeKey])

    useEffect(() => {
    }, [loading])

    const setAll = async () => {
        let allRests = await utilsCategurys.getRestsByCatId(props.pageId);

        let temp = [...allRests];
        let readylist = myFunctions.getShufBuissClosAtLast(temp,master)
        // מי שלא מגיע לעיר של הלקוח - בסוף (placeRank מהשרת)
        readylist = byPlaceRank(readylist);
        // let readylist = MyFunctions.setSHuffled(temp, []);
        // setShufMe(readylist);
        setShufMe(readylist);
        setLoading(false);

    }


    return (
        <div>
            {
                <>
                    <WaitImgOverlay item={waitImgItm} ready={!loading} />

                    {loading ? "" :
                        <RestSmallBlock mainRests={shufMe} />
                    }
                </>

            }
        </div >
    )
}

export default CategurysList;